@if (infotext(); as infotext) {
  <div
    [@fadeIn]
    class="pointer-events-auto absolute z-[1001] w-full overflow-y-auto rounded-lg bg-white p-4 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.12)] [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    [style.top.px]="infotext.top"
    [style.max-height.px]="infotext.maxHeight"
  >
    @if (infotext.template) {
      <ng-container [ngTemplateOutlet]="infotext.template" />
    } @else {
      <p class="m-0 text-base" [innerHTML]="infotext.text"></p>
    }
  </div>
}
